module.exports = __webpack_public_path__ + "img/mild-smiley.f8767f00.png";